import React, { useEffect, useRef, useState } from "react";

declare const window: any;

const TooltipContainer = React.memo(
  ({
    frame,
    isSelectedApto,
    setIsSelectedApto,
    theme,
    originalWidth,
    originalHeight,
    attributes,
    cotizacion,
    setGaleriaSelected,
    setOriginalGleriaSelected,
    setSubMenuSelected,
  }: //active
  any) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    // Inicializar la useRef con el valor inicial de `frame`
    const prevFrameRef = useRef(frame);

    useEffect(() => {
      // Calcular la posición proporcional del div en el viewport
      const posX = (isSelectedApto?.verts[0][0] / originalWidth) * screenWidth;
      const posY =
        (isSelectedApto?.verts[0][1] / originalHeight) * screenHeight;

      /* animation-name: swipe-show-hotspots
    animation-duration: 0.5s
    transform-origin: bottom
    opacity: 1 */

      // Colocar el div en la posición calculada
      const targetDiv: any = document.getElementById("tooltip-container");
      targetDiv.style.left =
        !window.functionIsPortrait() && window.functionIsMobileDevice()
          ? `${posX + 210 > screenWidth ? posX - 210 : posX + 50}px`
          : window.functionIsPortrait() && window.functionIsMobileDevice()
          ?`${posX + 200 > screenWidth ? posX - 200 : posX + 20}px`
          : `${posX + 420 > screenWidth ? posX - 420 : posX + 100}px`;
      console.log(posY - 165);
      console.log(screenHeight);

      targetDiv.style.top =
        !window.functionIsPortrait() && window.functionIsMobileDevice()
          ? `${posY - 165 >= 0 ? posY - 165 : 5}px`
          : `${posY - 195}px`;
      targetDiv.classList.add("tooltip-animation");

      setTimeout(() => {
        targetDiv.classList.remove("tooltip-animation");
      }, 501);
    }, [isSelectedApto, screenWidth, screenHeight]);

    useEffect(() => {
      if (JSON.stringify(prevFrameRef.current) !== JSON.stringify(frame)) {
        console.log(frame);
        setIsSelectedApto({});

        // Actualiza la referencia al frame actual para la próxima comparación
        prevFrameRef.current = frame;
      }
    }, [frame]);

    return (
      <div id="tooltip-container" className={`tooltip-container ${theme}`}>
        <div className="tooltip-container-header">
          <div>Inmueble {isSelectedApto?.property}</div>
          <div>
            <i
              className="fas fa-xmark"
              onClick={() => setIsSelectedApto({})}
            ></i>
          </div>
        </div>
        <div className="tooltip-container-jerarquia">
          {
            isSelectedApto?.values?.find(
              (e) => e.hierarchicalLevel === "Jerarquico #2"
            )?.value
          }
          {isSelectedApto?.values?.find(
            (e) => e.hierarchicalLevel === "Jerarquico #2"
          ) !== undefined
            ? "  /  "
            : null}
          {
            isSelectedApto?.values?.find(
              (e) => e.hierarchicalLevel === "Jerarquico #1"
            )?.value
          }
        </div>
        <div className="tooltip-container-attributes">
          {isSelectedApto?.values?.map((e) => {
            if (e.type !== "Hierarchical") {
              return (
                <div className="tooltip-container-attributes-row">
                  <div>
                    {attributes?.find((a) => a.id === e.attribute).name}: {e.value}
                  </div>
                  {/* <div>{e.value}</div> */}
                </div>
              );
            }
          })}

          {isSelectedApto.price > 0 ? <div className="tooltip-container-attributes-row">
            <div>Precio</div>
            <div>
              {new Intl.NumberFormat("es-CO", {
                style: "currency",
                currency: "COP",
              }).format(isSelectedApto.price)}
            </div>
          </div> : null}
          {isSelectedApto?.galleries?.length > 0 ? (
            <div
              className="tooltip-container-attributes-button-gallery"
              onClick={() => {
                setGaleriaSelected(isSelectedApto?.galleries),
                  setSubMenuSelected("Galería"),
                  setOriginalGleriaSelected(isSelectedApto?.galleries);
              }}
            >
              <i className={`fa-regular fa-images`}></i>
              Ver galería
            </div>
          ) : null}
        </div>
        {cotizacion ? (
          <div className="tooltip-container-button-cotizacion">
            Agregar a cotización
          </div>
        ) : null}
        {cotizacion ? (
          <div className="tooltip-container-label-cotizacion">
            Has seleccionado el máximo de inmuebles. Ve a{" "}
            <strong>Cotiza</strong> para gestionar los inmuebles seleccionados.
          </div>
        ) : null}
      </div>
    );
  }
);

export default TooltipContainer;
